import React, { useState } from "react";
import "./media.scss";
import { Modal } from "react-bootstrap";
import MediaGallery from "./mediaGallery";
import MultipartUploadService from "../../../../../services/MultipartUploadService";
import { Api_Url } from "../../../../../utils/ApiUrl";

const Media = ({ projectSetup, setProjectSetup }) => {
  const [files, setFiles] = useState([]);
  const [image, setImage] = useState(null);
  const [desktopBanner, setDesktopBanner] = useState(null);
  const [show1, setShow1] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleClickUpload = () => {
    document.getElementById("mediaInput").click();
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files).map((file) => ({
      file,
      progress: 0,
    }));
    setFiles((prev) => [...prev, ...selectedFiles]);

    // Simulate upload
    selectedFiles.forEach((f) => {
      const interval = setInterval(() => {
        setFiles((prevFiles) => {
          const updatedFiles = [...prevFiles];
          const fileIndex = prevFiles.indexOf(f);
          if (!updatedFiles[fileIndex]) return updatedFiles;
          if (updatedFiles[fileIndex].progress < 100) {
            updatedFiles[fileIndex].progress += 5;
          } else {
            clearInterval(interval);
          }
          return updatedFiles;
        });
      }, 100);
    });
  };

  const handleDelete1 = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUpload = (event) => {
    const file = event.target.files[0];
    if (file) setImage(URL.createObjectURL(file));
  };

  const handleDesktopBannerUpload = (event) => {
    const file = event.target.files[0];
    if (file) setDesktopBanner(URL.createObjectURL(file));
  };

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const handleShow = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const uploadService = new MultipartUploadService({
    baseURL: Api_Url,
    chunkSize: 5 * 1024 * 1024,
    threadsQuantity: 5,
    getAuthToken: () => localStorage.getItem("accessToken"),
    transformUrl: (url) =>
      url.startsWith("https://gems-media.s3.us-west-2.amazonaws.com/")
        ? url.replace(
            "https://gems-media.s3.us-west-2.amazonaws.com/",
            "https://dh3bzuu7a45gi.cloudfront.net/"
          )
        : url,
  });

  const handleFileSelect = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const totalSize = files.reduce((sum, file) => sum + file.size, 0);
    if (totalSize > 300 * 1024 * 1024) {
      setProjectSetup((prev) => ({
        ...prev,
        projectMedia: {
          ...prev.projectMedia,
          error: true,
          errorMsg: `Total file size exceeds 300MB. Selected: ${(
            totalSize /
            1024 /
            1024
          ).toFixed(2)}MB`,
        },
      }));
      e.target.value = "";
      return;
    }

    setProjectSetup((prev) => ({
      ...prev,
      projectMedia: {
        ...prev.projectMedia,
        error: false,
        errorMsg: "",
      },
    }));

    const startIndex = projectSetup.projectMedia.value.length;
    const newMediaItems = files.map((file) => ({
      title: file.name,
      file,
      progress: 0,
      url: null,
    }));

    setProjectSetup((prev) => ({
      ...prev,
      projectMedia: {
        ...prev.projectMedia,
        value: [...prev.projectMedia.value, ...newMediaItems],
      },
    }));

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileIndex = startIndex + i;

      try {
        const result = await uploadService.uploadFile(file, {
          destination: "project",
          onProgress: (percentage) => {
            setProjectSetup((prev) => ({
              ...prev,
              projectMedia: {
                ...prev.projectMedia,
                value: prev.projectMedia.value.map((item, idx) =>
                  idx === fileIndex ? { ...item, progress: percentage } : item
                ),
              },
            }));
          },
        });

        setProjectSetup((prev) => ({
          ...prev,
          projectMedia: {
            ...prev.projectMedia,
            value: prev.projectMedia.value.map((item, idx) =>
              idx === fileIndex
                ? { ...item, progress: 100, url: result.fileUrl }
                : item
            ),
          },
        }));
      } catch (error) {
        console.error(`Upload failed for ${file.name}:`, error);
        setProjectSetup((prev) => ({
          ...prev,
          projectMedia: {
            ...prev.projectMedia,
            value: prev.projectMedia.value.filter((_, idx) => idx !== fileIndex),
          },
        }));
        alert(`Upload failed for ${file.name}: ${error.message}`);
      }
    }

    e.target.value = "";
  };

  const handleDelete = (e, index) => {
    setProjectSetup((prev) => ({
      ...prev,
      projectMedia: {
        ...prev.projectMedia,
        value: prev.projectMedia.value.filter((_, i) => i !== index),
      },
    }));
  };

  return (
    <>
      <section className="media-section">
        <div className="first-para document_plays" style={{ margin: 0 }}>
          <h2>PROJECT GALLERY <span></span></h2>
          <button onClick={handleShow1}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path d="M10.5 15H3V3H15V10.5" stroke="#329879" strokeWidth="1.5"/>
              <path d="M3 14.25L9.75 7.5L12.75 10.5" stroke="#329879" strokeWidth="1.5"/>
              <path d="M7.5 3C7.5 5.48528 5.48528 7.5 3 7.5" stroke="#329879" strokeWidth="1.5"/>
              <path d="M14.6249 12V14.625M14.6249 14.625V17.25M14.6249 14.625H17.25M14.6249 14.625H12" stroke="#329879" strokeWidth="1.5"/>
            </svg>
            Add Media
          </button>
        </div>

        <div className="bottom-gallery">
          <MediaGallery
            items={projectSetup?.projectMedia?.value}
            handleDelete={handleDelete}
            handleShow={handleShow}
          />
        </div>

        {projectSetup.projectMedia.error && (
          <p className="error-text">{projectSetup.projectMedia.errorMsg}</p>
        )}
      </section>

      {/* Image Preview Modal */}
      <Modal className="common-modal-style image-preview" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="p-0">
          <img src={selectedImage} alt="Selected" className="img-fluid w-100" />
        </Modal.Body>
      </Modal>

      {/* Add Media Modal */}
      <Modal className="publish-modall" show={show1} onHide={handleClose1} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Media</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="publish_modal">
            <div className="top_twosidess">
              <div className="leftside_tab lastnews">
                <div className="lowerbox" style={{ cursor: "pointer", textAlign: "center" }} onClick={handleClickUpload}>
                  <img src="/assets/downlodimg.svg" alt="Placeholder" />
                  <h6>Drag & Drop Video or Image</h6>
                  <h3 style={{ fontSize: "12px", opacity: 0.7 }}>Max 300MB • PNG/JPEG/MP4</h3>
                </div>
                <input type="file" id="mediaInput" accept="image/png, image/jpeg, video/mp4" multiple hidden onChange={handleFileSelect} />
                
                {projectSetup.projectMedia.value.map((item, i) => (
                  <div key={i} style={{ marginTop: "12px" }}>
                    <div className="progresssbarr">
                      <div className="fileinfo">
                        <h2>{item?.title}</h2>
                        {item?.file ? (
                          <p>.{item.file.type.split("/")[1].toUpperCase()} | {(item.file.size / 1024 / 1024).toFixed(2)} MB</p>
                        ) : (
                          <p style={{ color: "#e3ecf0" }}>.</p>
                        )}
                      </div>
                      <div className="progress_right">
                        {item.progress === 100 || !item?.file ? (
                          <button className="buttondeeel" onClick={() => handleDelete(i, i)}>Delete</button>
                        ) : (
                          <>
                            <div className="progress_track">
                              <div className="progress_fill" style={{ width: `${item.progress}%` }} />
                            </div>
                            <span className="percentage">{item.progress.toFixed(2)}%</span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="publish_buttons">
              <button onClick={handleClose1} className="cancel_button">Cancel</button>
              <button className="confirm_button" onClick={handleClose1}>Confirm</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Media;
